import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {NotificationSliceProps, FetchNotificationsRespons} from './types'
import {fetchNotifications} from './service'

const initSlice: NotificationSliceProps = {
  listLoading: false,
  error: undefined,
  notifications: [],
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initSlice,
  reducers: {
    resetNotifications: (state: NotificationSliceProps) => {
      state.notifications = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotifications.pending, (state: NotificationSliceProps) => {
      state.listLoading = true
      state.error = undefined
    })
    builder.addCase(
      fetchNotifications.fulfilled,
      (state: NotificationSliceProps, action: PayloadAction<FetchNotificationsRespons>) => {
        state.notifications = action.payload.notifications
        state.listLoading = false
        state.error = undefined
      }
    )
    builder.addCase(fetchNotifications.rejected, (state: NotificationSliceProps) => {
      state.listLoading = false
      state.error = 'error'
    })
  },
})

const notificationsReducer = notificationsSlice.reducer
export const {actions} = notificationsSlice
export default notificationsReducer
